import { Grid, Snackbar, TextField, Typography } from "@mui/material";
import Sidebar from "./Sidebar";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function Options() {

    var navi = useNavigate();

    function CheckLogIn() {

        var id = localStorage.getItem('uuid');
        if (id == '') {
            navi('/')
        }

    }

    useEffect(() => {
        CheckLogIn();
    }, [])


    var url = `http://localhost:${process.env?.PORT || 3000}/`;

    // const [data, setdata] = useState();
    var uid = localStorage.getItem('uuid');
    function getData() {
        var id = localStorage.getItem('uuid');
        console.log(id);
        axios.post(url + 'getShop', {
            Id: id
        }).then((succ) => {
            var data = succ.data;
            setshopData(data);
            setformData({
                Name: data.Name,
                Address: data.Address,
                Email: data.Email,
                Phone: data.Phone
            })
            console.log(succ.data);
        })
    }
    useEffect(() => {
        getData();
    }, [])

    const [shopData, setshopData] = useState(null);
    const [formData, setformData] = useState({
        Name: '',
        Address: '',
        Phone: '',
        Email: ''
    })

    const [succcess, setsuccess] = useState(false);
    const [fail, setfail] = useState(false);
    function saveCredentialChanges(e) {
        e.preventDefault();
        var data = new FormData(e.currentTarget);
        // var name = 
        // var name = data.get('name')
        // var address = data.get('address');
        // var phone = data.get('phone');
        // var email = data.get('email');

        axios.post(url + 'saveCredentialChanges', {
            Id: uid,
            Name: formData.Name,
            Address: encodeURIComponent(formData.Address),
            Phone: formData.Phone,
            Email: formData.Email
        }).then((succ) => {
            getData();
            setsuccess(true);
            e.target.reset();
            // setshopData({
            //     Name: formData.Name,
            //     Address: formData.address,
            //     Phone: formData.phone,
            //     Email: formData.email
            // });
        }).catch((erorr) => {
            // console.log(error)
            setfail(true)
        })
    }

    function handleChange(e) {
        const { name, value } = e.target;
        setformData(prev => ({
            ...prev,
            [name]: value
            // console.log(prev)
        }))
    }

    const changed =
        shopData && (
            formData.Name !== shopData.Name ||
            formData.Address !== shopData.Address ||
            formData.Phone !== shopData.Phone ||
            formData.Email !== shopData.Email
        );

    return (
        <>

            <Grid container height={'100vh'} className='admin-Section' width={'100%'}>
                <Sidebar />
                <Grid pt={3} pr={3.3} size={{ lg: 9.6 }}>
                    <Grid container justifyContent={'space-between'}>
                        <Grid size={{ lg: 5.8 }} p={4} className='admin-section shadow'>
                            <Typography variant="h5">Credentials</Typography>
                            {/* <TextField /> */}
                            {/* <input type="text" className="form-control mt-3" placeholder="Give Suitable Title for the image" /> */}
                            <form className="mt-3" onSubmit={saveCredentialChanges}>
                                <TextField onChange={handleChange} value={formData.Name} size="small" name="Name" placeholder='Name of your salon' fullWidth />
                                <TextField onChange={handleChange} value={decodeURIComponent(formData.Address)} size="small" className="mt-2" name="Address" placeholder='Address of your salon' fullWidth />
                                <TextField onChange={handleChange} value={formData.Email} size="small" className="mt-2" name="Email" placeholder='Email of your salon' fullWidth />
                                <TextField onChange={handleChange} value={formData.Phone} size="small" className="mt-2" name="Phone" placeholder='Phone of your salon' fullWidth />
                                <div className="d-flex justify-content-end">
                                    <button disabled={!changed} type="submit" className="btn btn-secondary mt-3 px-3">Save Changes</button>
                                </div>
                            </form>
                            <Snackbar message='Details edited' autoHideDuration={4500} open={succcess} />
                            <Snackbar message='Details edited' autoHideDuration={4500} open={fail} />
                        </Grid>
                        <Grid size={{ lg: 5.8 }} p={4} className='admin-section shadow'>
                            <Typography variant="h5">Timings</Typography>
                            <Grid container alignItems={'center'} className='mt-3' justifyContent={'space-between'}>
                                <TextField className="col-5" type="time" defaultValue={'10:30'} />
                                {/* <TextField className="col-5"  /> */}
                                <Typography variant="h4" className="col-2" textAlign={'center'}>-</Typography>
                                <TextField className="col-5" type="time" defaultValue={'10:30'} />
                            </Grid>
                            <div className="d-flex justify-content-end">
                                <button disabled={!changed} type="submit" className="btn btn-secondary mt-3 px-3">Save Changes</button>
                            </div>
                            {/* <TextField /> */}
                            {/* <input type="text" className="form-control mt-3" placeholder="Give Suitable Title for the image" /> */}

                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

        </>
    )

}